import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const fetchAllApplysRoutine = createRoutine('Applications/FETCH_ALL')
export const createFetchAllApplysPromise = promisifyRoutine(fetchAllApplysRoutine)

export const fetchApplyByIdRoutine = createRoutine('Applications/FETCH_BY_ID')
export const createFetchApplyByIdPromise = promisifyRoutine(fetchApplyByIdRoutine)

export const applyStepRoutine = createRoutine('Applications/STEP')
export const createApplyStep = promisifyRoutine(applyStepRoutine)

export const createApplyRoutine = createRoutine('Applications/CREATE')
export const createCreateApplyPromise = promisifyRoutine(createApplyRoutine)

// documents
export const requestInfoRoutine = createRoutine('Applications/docs/info')
export const createRequestInfoPromise = promisifyRoutine(requestInfoRoutine)

export const fetchRequiredDocumentsRoutine = createRoutine('Applications/docs/fetch')
export const createFetchRequiredDocumentsPromise = promisifyRoutine(fetchRequiredDocumentsRoutine)

export const checkDocumentsRoutine = createRoutine('Applications/docs/check')
export const createcheckDocumentsPromise = promisifyRoutine(checkDocumentsRoutine)

export const createHaciendaRoutine = createRoutine('Applications/docs/upload/hacienda')
export const createHaciendaPromise = promisifyRoutine(createHaciendaRoutine)
export const HACIENDA_BLOCKED = 'Applications/docs/upload/hacienda/BLOCKED'
export const haciendaBlockedAction = () => ({
  type: HACIENDA_BLOCKED
})

export const uploadFilesRoutine = createRoutine('Applications/docs/upload/files')
export const createUploadFilesPromise = promisifyRoutine(uploadFilesRoutine)
